export const teamManagement = {
  forbidden: {
    title: "Restricted access",
    desc: "Only the main host can manage the team.",
  },
  header: {
    title: "Team management",
    subtitle: "Manage who can access your property's dashboard",
    addMember: "Add member",
  },
  stats: {
    totalTeam: "Total team",
    host: "Host",
    additionalMembers: "Additional members",
  },
  search: {
    placeholder: "Search by name or email…",
  },
  loading: "Loading team…",
  table: {
    member: "Member",
    email: "Email",
    role: "Role",
    properties: "Properties",
    added: "Added",
    actions: "Actions",
    ownerBadge: "Host",
    mainHost: "Main host",
    viewPermissions: "View allowed features",
    allProperties: "All",
    unassigned: "Unassigned",
    notEditable: "Not editable",
    edit: "Edit",
    delete: "Delete",
  },
  surfaces: {
    web: "Web",
    app: "App",
  },
  empty: {
    title: "No additional members",
    desc: "Use the <strong>Add member</strong> button to invite people to your team.",
  },
  infoBanner:
    "Team members access the dashboard with their own username and password. Each profile has fixed permissions and data access is enforced on the server. Owner signs in via web only; cleaning and maintenance, app only. The <strong>main host</strong> always has full access and cannot be removed.",
  modal: {
    createTitle: "Add member",
    editTitle: "Edit member",
    nameLabel: "Full name",
    namePlaceholder: "e.g. Maria Garcia",
    emailLabel: "Email address",
    emailPlaceholder: "email@example.com",
    roleLabel: "Access profile",
    viewScope: "View scope",
    accessIncluded: "Access included",
    assignedProperties: "Assigned properties",
    selectedCount: "({selected} of {total} selected)",
    propertySearchPlaceholder: "Search property…",
    selectAll: "Select all",
    clear: "Clear",
    noResults: 'No results for "{query}"',
    selectAtLeastOneHint: "Select at least one property for this profile.",
    noPropertiesWarning:
      "There are no properties available to assign. Create a property before saving this profile.",
    passwordLabel: "Password",
    passwordOptional: "(leave blank to keep unchanged)",
    passwordPlaceholder: "At least 8 characters",
    confirmPasswordLabel: "Confirm password",
    confirmPasswordPlaceholder: "Repeat password",
    showPassword: "Show password",
    hidePassword: "Hide password",
    cancel: "Cancel",
    create: "Create member",
    save: "Save changes",
  },
  deleteModal: {
    title: "Delete member",
    subtitle: "This action cannot be undone",
    confirm:
      "Are you sure you want to remove {name} from the team? They will lose access to the dashboard immediately.",
    cancel: "Cancel",
    delete: "Delete",
  },
  roleInfo: {
    defaultTitle: "Permissions",
    description:
      "This profile is fixed. Its scope, access surface and properties are also validated on the server.",
    understood: "Got it",
  },
  roleDescriptions: {
    anfitrion: "Full access to all properties from web and app.",
    propietario:
      "Calendars and analytics for assigned properties only. Web access.",
    limpieza:
      "Start cleaning, tasks and messages for their properties. App only.",
    mantenimiento:
      "Start maintenance, tasks and messages for their properties. App only.",
    fallback: "Compatibility profile with restricted access.",
  },
  optionalHints: {
    messages:
      "View and reply to chats for their properties. If disabled, they won't see messages or receive their notifications.",
  },
  toasts: {
    loadError: "Couldn't load the team.",
    memberAdded: "✓ Member added to the team.",
    memberUpdated: "✓ Member updated.",
    saveError: "Couldn't save. Please try again.",
    memberDeleted: "Member removed from the team.",
    deleteError: "Couldn't remove the member.",
  },
};
